import React from 'react'
import EodShapedQueue from '../shared/EodShapedQueue'

// The light EOD jobs, kept off the heavy queue so they never wait behind it.
// Which job failed is in the row's name, so the wording stays general.
const CriticalTasksQueue = () => (
    <EodShapedQueue
        queue="critical-tasks"
        title="Critical Tasks"
        depthText="light outlet task(s) still queued or running — these run one at a time but are quick, so a backlog here should clear fast."
        failedText="light outlet task(s) did not finish. Check the job name on each row for which task it was."
    />
)

export default CriticalTasksQueue
